Ext.BLANK_IMAGE_URL = '/admin-ui/images/s.gif';

Ext.ns('mx');

mx.DELIMETER = '/'; // delimeter of nested pages in #hash
mx.DEFAULT_MAX_LENGTH = 255; // maximum length of moust inputs in ui forms

mx.PATH = window.location.protocol + '//' + window.location.host + MX_DIR; // path to current app-template api endpoints
mx.MXPATH = window.location.protocol + '//' + window.location.host + MXM_DIR; // path to maxoptra management endpoints
mx.ENTRY = window.location.protocol + '//' + window.location.host + '/'; // application host url
mx.CURRENT = window.location.protocol + '//' + window.location.host + window.location.pathname; // requested page url

/**
 * Dates and addresses formatter, that is used twice in map-resource?
 * todo: refactor this, it's inappropriate way to format dates and addresses on ui
 */
mx.Formatter = mx.Formatter || null; // It will be assigned by template

/**
 * Application object, which bootstraps an application
 * @usage Ext.onReady(function () { application = new mx.Application(); });
 */
mx.Application = Ext.extend(Ext.Component, {
    pathPrefix: [], // never really used

    schedulingInProgress: false, // todo: refactor this, doesn't suit here
    user: null, // first row in response of "users/current"

    /*
     * all working with cookies here needs refactoring
     */
    getCookieName: function(mainPart) {
        // used once?
        return (
            mainPart +
            '.' +
            this.user.login +
            '.' +
            this.user.currentRole +
            (this.user.region_id != null ? '.' + this.user.region_id : '')
        );
    },

    setCookie: function(nameMainPart, val) {
        // used once?
        mx.Util.Cookies.getCookieProvider().set(this.getCookieName(nameMainPart), val);
    },

    getCookie: function(nameMainPart) {
        // never used?
        return mx.Util.Cookies.getCookieProvider().get(this.getCookieName(nameMainPart));
    },

    isCookieSet: function(nameMainPart) {
        // never used?
        return !!mx.Util.Cookies.getCookieProvider().get(this.getCookieName(nameMainPart));
    },

    plugins: new mx.plugin.Navigable({
        ns: function() {
            return mx.app.page;
        },
        container: function() {
            return this.viewport;
        },
    }),

    initComponent: function() {
        //localization
        if (mx.Localization && window.MXBT) {
            if (!mx.LocalizationDescriptor) {
                mx.LocalizationDescriptor = function() {};
            }
            mx.Localization.localize(MXBT.data['LOC'], new mx.LocalizationDescriptor());
        }

        // some global settings
        Ext.QuickTips.init();
        Ext.useShims = true;
        Ext.History.init();

        // init viewport
        this.viewport = new Ext.Viewport({
            layout: 'fit',
            border: false,
            cls: 'index_viewport',
        });

        // on every change of hash in location, we execute navigate
        Ext.History.on(
            'change',
            function(hash) {
                var path = hash ? hash.split(mx.DELIMETER) : [];

                path.unshift(path.length ? 'Main' : 'Login');

                this.navigate(path);

                // store last used path in a cookie
                if (window.userId) {
                    var json = mx.Util.Cookies.getCookieProvider().get('navigable_path');
                    path = json ? Ext.decode(json) : {};
                    if (path[userId] && path[userId][ur]) {
                        path[userId][ur] = hash;
                    } else {
                        if (!path[userId]) {
                            var obj = {};
                            obj[ur] = hash;
                            path[userId] = obj;
                        } else {
                            path[userId][ur] = hash;
                        }
                    }
                    mx.Util.Cookies.getCookieProvider().set('navigable_path', Ext.encode(path));
                }

                this.viewport.doLayout();
            },
            this
        );

        this.on('navigable_ready', function() {
            var path = mx.Util.Cookies.getCookieProvider().get('navigable_path');
            var hash =
                path && window.userId && !window.location.hash.substr(1)
                    ? window.defaultPage
                        ? window.defaultPage
                        : Ext.decode(path)[userId]
                            ? Ext.decode(path)[userId][ur]
                            : ''
                    : window.location.hash.substr(1);
            Ext.History.fireEvent('change', hash);
        });

        Ext.ux.event.Broadcast.addEvents('got_user_login');
        Ext.ux.event.Broadcast.addEvents('got_user_logout');
    },
});

// todo: move this to something more apropriate
mx.Application.getUserTimezone = function(user) {
    var dispatchingDepots = user.dispatcher_depot.length != 0 ? user.dispatcher_depot : user.manager_depot;
    if (dispatchingDepots.length == 1) {
        return dispatchingDepots[0].time_zone;
    }
    return null;
};

mx.Application.authenticate = function() {
    Ext.Ajax.request({
        url: mx.PATH + MXAT.API('users/current'),
        success: function(r) {
            var response = Ext.util.JSON.decode(r.responseText);
            if (response.rows.length) {
                application.user = response.rows[0];
                application.user.timezone = mx.Application.getUserTimezone(application.user);
                Ext.ux.event.Broadcast.fireEvent('got_user_login');
            }
        },
    });
};

mx.Application.onauthenticated = function(callback, scope) {
    if (application && application.user) {
        callback.call(scope || this);
    } else {
        Ext.ux.event.Broadcast.on('got_user_login', callback, scope || this);
    }
};
